import { ChangelogDialog } from 'armxlib'
import { Outlet, ScrollRestoration } from 'react-router'
import { en } from '../i18n/en'
import { useInternalLinks } from './links'
import { useWhatsNew } from './version'

/** Wraps every page: client-side links, scroll restoration, and the "What's new" popup after an update. */
export function Root() {
  useInternalLinks()
  const [changelog, close] = useWhatsNew()

  return (
    <>
      <ScrollRestoration />
      <Outlet />
      <ChangelogDialog
        open={changelog !== null}
        onClose={close}
        title={en.update.whatsNew}
        dismissLabel={en.common.close}
        entries={changelog ? [{ version: changelog.date, changes: changelog.changes }] : []}
      />
    </>
  )
}
